// extracted by mini-css-extract-plugin
export default {"mobileLink":"pguwbURcWLhxOdWqY5ZS","link":"HVQ0I2KH9Wf4IUSBixUg"};